import { Check } from "lucide-react";
import { Reveal, FadeUp } from "@/components/site/Reveal";
import { useSiteContent } from "@/context/ContentContext";

export default function Specialty() {
  const { specialty: SPECIALTY } = useSiteContent();
  return (
    <section id="studio-intro" data-testid="specialty-section" className="relative bg-[#f8fafc] py-24 md:py-36">
      <div className="mx-auto max-w-[1200px] px-6 md:px-12 text-center">
        <FadeUp>
          <p className="overline !text-[#9c7a4d] mb-8">{SPECIALTY.overline}</p>
        </FadeUp>
        <h2 className="font-serif font-light text-[#0f172a] text-4xl sm:text-5xl lg:text-7xl leading-[1] tracking-tight mb-10">
          <Reveal>Every Aspect</Reveal>
          <Reveal delay={0.08}>of Tiling.</Reveal>
        </h2>
        <FadeUp delay={0.1}>
          <p className="text-[#475569] text-lg md:text-xl font-light leading-relaxed max-w-3xl mx-auto mb-16">
            {SPECIALTY.body}
          </p>
        </FadeUp>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-6 max-w-3xl mx-auto text-left">
          {SPECIALTY.points.map((p, i) => (
            <FadeUp key={p} delay={0.12 + i * 0.06}>
              <div className="flex items-start gap-4 border-b border-[#0f172a]/10 pb-5">
                <Check className="h-5 w-5 text-[#9c7a4d] shrink-0 mt-0.5" />
                <span className="text-[#1e293b] text-base md:text-lg font-light">{p}</span>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
